import { ref } from 'vue'
import { defineStore } from 'pinia'

const useConfigStore = defineStore('config', () => {
    /**
     * 配置
     */
    const config = ref<any>(null)

    /**
     * 错误信息
     */
    const errorInfo = ref<{
        show: boolean
        message: string
        callback?: () => void
    }>({
        show: false,
        message: ''
    })

    /**
     * 设置错误信息
     */
    const setErrorInfo = (info: {
        show: boolean
        message: string
        callback?: () => void
    }) => {
        errorInfo.value = info
    }

    /**
     * 清除错误信息
     */
    const clearErrorInfo = () => {
        errorInfo.value = {
            show: false,
            message: ''
        }
    }


    return {
        config,
        errorInfo,
        setErrorInfo,
        clearErrorInfo
    }
})

export default useConfigStore